import { generatePath } from 'react-router';

export const HOME_PATH = '/';
export const FORGOT_PASSWORD_PATH = '/forgot-password';

export const USERS_OVERVIEW_PATH = '/users/overview';
export const USER_DETAIL_PATH = '/users/:userId';
export const getUserPath = (userId: string) => generatePath(USER_DETAIL_PATH, { userId });

export const USER_GROUPS_OVERVIEW_PATH = '/users/groups/overview';
export const USER_GROUPS_DETAIL_PATH = '/users/groups/:id';
export const getUserGroupPath = (id: string) => generatePath(USER_GROUPS_DETAIL_PATH, { id });

export const DEVICES_OVERVIEW_PATH = '/devices/overview';
export const DEVICE_DETAIL_PATH = '/devices/:deviceId';
export const getDevicePath = (deviceId: string) => generatePath(DEVICE_DETAIL_PATH, { deviceId });

export const DEVICE_GROUPS_PATH = '/devices/groups';
export const DEVICE_GROUP_DETAIL_PATH = '/devices/groups/:groupId';
export const getDeviceGroupPath = (groupId: string) => generatePath(DEVICE_GROUP_DETAIL_PATH, { groupId });

export const CLOUD_CONTROLLER_DETAIL_PATH = '/devices/cloud-controllers/:cloudControllerId';
export const getCloudControllerPath = (cloudControllerId: string) =>
  generatePath(CLOUD_CONTROLLER_DETAIL_PATH, { cloudControllerId });

export const CARDS_ACCESS_CARDS_PATH = '/cards/access-cards';
